module.exports = __webpack_public_path__ + "static/scale-model-of-ambiance-on-the-water-in-kansas-city-missouri-1da224a05ae44ba36c525ece1d023d99.png";